<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ row ? row.title : 'تفاصيل المشروع العقاري' }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link v-if="checkAccess('projects_read')" to="/projects">المشاريع العقارية</router-link><span v-else>المشاريع العقارية</span></li>
              <li class="breadcrumb-item active" aria-current="page">{{ editing ? 'تعديل المشروع' : 'تفاصيل المشروع' }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="app-content">
      <div class="container-fluid">
        <div v-if="!checkAccess('projects_read') && !checkAccess('projects_update')" class="alert alert-warning">ليس لديك صلاحية عرض المشاريع العقارية.</div>
        <template v-else>
          <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
          <mainLoader v-if="mainLoading" />
          <template v-else-if="row">
            <div class="row mb-3">
              <div class="col text-end">
                <button v-if="checkAccess('projects_update') && !editing" type="button" class="btn btn-primary" :disabled="formSaving" @click="editing = true">
                  <i class="bi bi-pencil-square me-1"></i> تعديل المشروع
                </button>
                <button v-if="editing && checkAccess('projects_read')" type="button" class="btn btn-light" :disabled="formSaving" @click="editing = false">العودة لتفاصيل المشروع</button>
              </div>
            </div>
            <div v-if="editing" class="row justify-content-center">
              <div class="col-12 col-sm-10">
                <ProjectsForm :key="row.id" :cardTitle="'تعديل مشروع: ' + row.title" :dataRow="row" @saved="onSaved" @saving="formSaving = $event" />
              </div>
            </div>
            <ProjectsView v-else :dataRow="row" :stats="stats" :monthlyCashflow="monthlyCashflow" :teamMembers="teamMembers" :admins="admins" :statuses="statuses" :teamRoles="teamRoles" :commissionTypes="commissionTypes" :propertyStatuses="propertyStatuses" @refresh="getRowData(true)" @busy="formSaving = $event" />
          </template>
          <div v-else class="card card-secondary card-outline mt-4">
            <div class="card-body text-center">
              <p>تعذر عرض بيانات المشروع.</p>
              <button type="button" class="btn btn-primary" @click="getRowData">إعادة المحاولة</button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import ProjectsForm from './form.vue';
import ProjectsView from './view.vue';

export default {
  name: 'ProjectsUpdate',
  components: { ProjectsForm, ProjectsView },
  data() {
    return {
      mainLoading: true, hasError: false, message: '', errorNumber: 0,
      row: null, stats: {}, monthlyCashflow: [], teamMembers: [], admins: [], statuses: {}, teamRoles: {}, commissionTypes: {}, propertyStatuses: {},
      editing: !checkAccess('projects_read') && checkAccess('projects_update'), formSaving: false, requestSerial: 0,
    };
  },
  methods: {
    checkAccess,
    getRowData(silent = false) {
      if (!checkAccess('projects_read') && !checkAccess('projects_update')) { this.mainLoading = false; return; }
      const serial = ++this.requestSerial;
      if (!silent) this.mainLoading = true;
      this.hasError = false;
      this.$http.get(`/api/admin/projects/retrieve/${this.$route.params.id}`).then(({ data }) => {
        if (serial !== this.requestSerial) return;
        this.row = data.row;
        this.stats = data.stats || {};
        this.monthlyCashflow = data.monthlyCashflow || [];
        this.teamMembers = data.teamMembers || [];
        this.admins = data.admins || [];
        this.statuses = data.statuses || {};
        this.teamRoles = data.teamRoles || {};
        this.commissionTypes = data.commissionTypes || {};
        this.propertyStatuses = data.propertyStatuses || {};
      }).catch(err => {
        if (serial !== this.requestSerial) return;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      }).finally(() => { if (serial === this.requestSerial) this.mainLoading = false; });
    },
    onSaved() { this.editing = !checkAccess('projects_read'); this.getRowData(); },
  },
  watch: { '$route.params.id'() { this.editing = !checkAccess('projects_read') && checkAccess('projects_update'); this.row = null; this.getRowData(); } },
  beforeRouteLeave() { return !this.formSaving; },
  beforeRouteUpdate() { return !this.formSaving; },
  created() { this.getRowData(); },
  beforeUnmount() { this.requestSerial += 1; },
};
</script>
